import {
  toWSDateString,
  useModalOldContext,
  WSButton,
  WSButtons,
  WSElementProps,
  WSModalOld,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { Currency, Payable, PayableStatus } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { useHistory } from "react-router-dom";
import { queriesPayableRows, queriesPayables } from "@query";
import { QUERY_PAYABLES } from "../../../query/payments/keys";

const PAYABLE_LIST_DEPENDENCIES = [
  QUERY_PAYABLES,
  queriesPayableRows.searchPayableRows.queryKeyBase
];

type Props = WSElementProps;

export const DELETE_PAYABLE_MODAL = "DELETE_PAYABLE_MODAL";

export const DeletePayableModal: React.FC<Props> = () => {
  const { closeModal } = useModalOldContext();
  const history = useHistory();
  const [deletePayable, deletePayableMeta] =
    queriesPayables.deletePayable.useMutation({
      dependencies: PAYABLE_LIST_DEPENDENCIES
    });
  const [cancelPayable, cancelPayableMeta] =
    queriesPayables.cancelPayable.useMutation({
      dependencies: PAYABLE_LIST_DEPENDENCIES
    });

  return (
    <WSModalOld name={DELETE_PAYABLE_MODAL} size="M">
      {({
        payable,
        payeeName,
        listName
      }: {
        payable?: Payable;
        payeeName?: string;
        listName?: "paid";
      }) => {
        const isCancel = payable
          ? [PayableStatus.PENDING, PayableStatus.OPENED].includes(
              payable.status!
            )
          : false;

        const toText = payeeName ? ` to ${payeeName}` : "";

        const onSuccess = () => {
          closeModal(DELETE_PAYABLE_MODAL);
          history.push(
            `/member/invoices/payables${listName ? `/${listName}` : ""}`
          );
        };

        const dueDate = payable?.dueDate ?? new Date();

        const amount = payable?.amount ?? 0;

        return (
          <>
            <WSText.Heading5 mb="M">
              {isCancel ? "Cancel" : "Delete"} invoice
              {toText}
            </WSText.Heading5>
            <WSText mb="M">
              Are you sure you want to {isCancel ? "cancel" : "delete"} your{" "}
              {toWSDateString(dueDate, "monthDayYear")} invoice
              {toText} for{" "}
              {formatMoney(amount, (payable?.currency || "USD") as Currency)}?
            </WSText>
            <WSText mb="XL">
              This action can't be undone, once you{" "}
              {isCancel ? "cancel" : "delete"} an invoice you'll have to
              recreate it.
            </WSText>

            <WSButtons format="modal">
              <WSButton
                destructive
                name="delete"
                onClick={() => {
                  if (payable) {
                    if (isCancel) {
                      cancelPayable({ payableId: payable.id! }, { onSuccess });
                    } else {
                      deletePayable({ payableId: payable.id! }, { onSuccess });
                    }
                  }
                }}
                loading={
                  cancelPayableMeta.isLoading || deletePayableMeta.isLoading
                }
              >
                {isCancel ? "Cancel" : "Delete"} invoice
              </WSButton>
              <WSButton.Secondary
                onClick={() => {
                  closeModal(DELETE_PAYABLE_MODAL);
                }}
              >
                Keep invoice
              </WSButton.Secondary>
            </WSButtons>
          </>
        );
      }}
    </WSModalOld>
  );
};
